export const routerMetaDataMixin = (properties) => ({
  data() {
    return {
      meta: {},
    };
  },
  beforeCreate() {
    // Register a navigation guard
    this.unregisterGuard = this.$router.beforeEach((to, from, next) => {
      this.handleRouteChange(to); // Run your logic for route transitions
      next();
    });
  },
  created() {
    // Handle direct access on initial load
    this.handleRouteChange(this.$route);
  },
  beforeDestroy() {
    // Unregister the navigation guard
    if (this.unregisterGuard) {
      this.unregisterGuard();
    }
  },
  methods: {
    handleRouteChange(route) {
      for (const property of properties) {
        this.meta[property] = this.getDataFromMeta(route, property);
      }
    },
    getDataFromMeta(route, property) {
      // Traverse the `matched` array from child to parent
      for (let i = route.matched.length - 1; i >= 0; i--) {
        const record = route.matched[i];
        if (record.meta && record.meta[property]) {
          return record.meta[property];
        }
      }
      // Default value if no staticData is found
      return null;
    },
  },
});
